module.exports = __webpack_public_path__ + "img/johan_cv_1.a6eee70a.jpg";